export const MODULE = 'NOV';

export const SEARCH_BILLING = `${MODULE}/search_billing`;
export const CREATE = `${MODULE}/create_nov`;